<div class="m-2">
  <kendo-label *ngIf="isLabelVisible()" [for]="getControlName()" [text]="getLabel()">
      <span *ngIf="isRequired()" class="required">*</span>
  </kendo-label>
  <kendo-dropdownlist *ngIf="isControlVisible()" [id]="getControlName()" [name]="getControlName()" [(ngModel)]="formValues[getName()]" [required]="isRequired()"
    [data]="getItems()" [textField]="getTextField()" [valueField]="getValueField()" [valuePrimitive]="true">
  </kendo-dropdownlist>
</div>